import { ConfigOption } from "@ngx-formly/core";
import { FibuAccountDropdownComponent } from "./controls/fibu-account-dropdown/fibu-account-dropdown.component";

export const FIBU_FORMLY_TYPES: ConfigOption["types"] = [
    { name: "formly-fibu-account-dropdown", component: FibuAccountDropdownComponent, wrappers: ["simple-title"] },
];
